import { links } from "@/constants/links";
import { http } from "../httpHandler";
import { TServerErrorResponse } from "@/types";
import { CrmConfiguration } from "@/types/crm-configuration";

export const GET_CRM_CONFIGURATION = "get-crm-configuration";

export const getCrmConfigurations = async (): Promise<
  CrmConfiguration[] | undefined
> => {
  try {
    const response = await http.get<CrmConfiguration[]>(
      links.crmConfiguration.index,
    );

    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};
